export default "__VITE_ASSET__e1cf3c81__"